import { ListItem, styled } from '@mui/material';

const StyledMainMenuListItem = styled(ListItem)(() => ({
  marginBottom: '10px'
}));

export default StyledMainMenuListItem;
